import { render } from "./Timeline.vue?vue&type=template&id=def4c430&scoped=true&ts=true"
import script from "./Timeline.vue?vue&type=script&lang=ts"
export * from "./Timeline.vue?vue&type=script&lang=ts"

import "./Timeline.vue?vue&type=style&index=0&id=def4c430&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def4c430"]])

export default __exports__